import React, { useState, useEffect } from 'react';
import { Outlet, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import axios from 'axios';
import useAxios from 'axios-hooks';

import { useAuth } from 'hooks/use-auth';
import { Equipment } from 'models';
import MyBread from 'components/Breadcrumbs';
import IndexPage from './Equipment';
import ProductionPage from './EquipmentProduction';
import StatusPage from './EquipmentStatus';


export default function EquipmentRoute() {
  const auth = useAuth();
  const params = useParams();

  const [equipment, setEquipment] = useState<Equipment>();

  const [{data, loading, error}, refetch] = useAxios({
    url: `/v0/equipments/${params.id}`,
    headers: auth.authorizationHeader,
    params: {
      factory_id: auth.factoryId
    }
  });

  useEffect(() => {
    // FIXME: 現状factory_idを指定していないので、複数equipmentが返される可能性あり
    setEquipment(data && data.length > 0 ? (
      data.map((a: any) => ({
        companyId: a.company_id,
        factoryId: a.factory_id,
        id: a.id,
        name: a.name,
        nameKana: a.name_kana,
        abbreviation: a.abbreviation
      } as Equipment))[0]
    ) : undefined);
  }, [data]);

  if (loading) {
    return (<p>Loading...</p>);
  }

  if (error) {
    return (<p>Error!</p>);
  }

  return (
    <Routes>
      <Route path="/*" element={<EquipmentLayout equipment={equipment} />}>
        <Route index element={<IndexPage equipment={equipment} />}/>
        <Route path="production" element={<ProductionPage equipment={equipment} />} />
        <Route path="status" element={<StatusPage equipment={equipment} />} />
        <Route path="*" element={<Navigate to="." />} />
      </Route>
    </Routes>
  );
}

// --------------------------------------------------------------------------------------
// Layout

interface LayoutProps {
  equipment?: Equipment;
}

function EquipmentLayout({equipment}: LayoutProps) {
  return (
    <Box sx={{width: '100%'}}>
      <MyBread />
      <Box sx={{m: 1}}>
        <Typography>
          対象設備:
          {equipment ? (
            <>[{equipment.id}] {equipment.name} {equipment.abbreviation}</>
          ) : (
            <>読み込みエラー</>
          )}
        </Typography>
        </Box>
      <Outlet />
    </Box>
  );
}

